// extracted by mini-css-extract-plugin
module.exports = {"greyBackground":"#F4F4F4","page":"styles_page__-nlZU","pageContent":"styles_pageContent__1DQbj"};